// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connectivityDiagnostic-results {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  margin-top: 60px;\n}\n\n.connectivityDiagnostic-resultItemIcon {\n  margin-bottom: 20px;\n}\n\n.connectivityDiagnostic-resultItemText {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
